export interface NumberRange {
  min: number;
  max: number;
}

export const NumberRangeOutputTransformer = (numberRange: NumberRange) => ({
  min: numberRange.min,
  max: numberRange.max,
});
